import React from 'react';

import { AppBar, Button, Card, Divider, Link, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Nav } from '../components/Interface';
import { MuiRouterLink } from '../components/CustomMui';

const useStyles = makeStyles((theme) => ({
  appBarWrapper: {
    flexGrow: 1,
  },
  appBar: {
    backgroundColor: '#E4EAEF',
    borderTop: '1px solid ' + theme.palette.neutral.light1,
    borderBottom: '1px solid ' + theme.palette.neutral.light1,
  },
  backLink: {
    fontSize: 18,
    marginRight: 26
  },
  title: {
    flexGrow: 1,
    fontWeight: 500,
  },
  main: {
    backgroundColor: theme.palette.neutral.light2,
    padding: 40,
  },
  card: {
    maxWidth: 1140,
    margin: '0 auto',
    padding: 60,
    borderRadius: 10,
    boxShadow: '0 1px 8px rgba(0,0,0,.15)',
  },
  sectionHeading: {
    fontSize: 30,
    lineHeight: '32px',
    marginBottom: 25,
  },
  paragraph: {
    fontSize: 20,
    lineHeight: '32px',
    letterSpacing: '.025em',
    color: theme.palette.neutral.dark2,
  },
  button: {
    '& .fas' : {
      fontSize: 15
    }
  },
  link: {
    textDecoration: 'underline'
  },
}));


/** 
 * @todo
 * 
 * Make typography styles from this page universal.
 * 
 * This page is the only "body" text page we have.
 * Ideally, the H1, H2, p, etc would match the styles 
 * for this page. But as it was done last, and updating the styles
 * might change styles elsewhere in the site, these styles have
 * not been made universal.
 * 
 */

export const About = () => {

  const classes = useStyles();


  return (
    <div>

      <Nav dense={true} active="about" />

      <div className={classes.appBarWrapper}>
        
        {/* Secondary Nav / Title */}
        <AppBar position="relative" className={classes.appBar} color="transparent" elevation={0}>
          <Toolbar>

            {/* Back link */}
            <Tooltip title="Return home">
              <MuiRouterLink to='/' className={classes.backLink}><i className="fas fa-arrow-left"></i></MuiRouterLink>
            </Tooltip>

            {/* Title */}
            <Typography component="h1" variant="h4" className={classes.title} noWrap={true}>
              PAVILION Information
            </Typography>


          </Toolbar>
        </AppBar>

    
      </div>

      <div className={classes.main}>

        <Card className={classes.card}>
          <Typography className={classes.sectionHeading} component="h2" variant="h6">
            About
          </Typography>

          <Typography className={classes.paragraph} component="p">
            PAVILION Interactive Builder (version 2020-12-31 v1.0) eliminates reliance on developers by putting the power of building 
            interactives in the hands of content creators. Content authors can create the rich interactive content types featured on 
            PAVILION, such as field checks, hotspots, progressions, simulations, sliders and timelines, without advanced HTML skills or 
            AFPIMS training. The PAVILION team can easily and efficiently build sleek interactive content to deliver engaging resources 
            for the fleet and field.
          </Typography>

          <Divider />

          <Typography className={classes.sectionHeading} component="h2" variant="h6">
            User Guide
          </Typography>

          <Typography className={classes.paragraph} component="p">
            The PAVILION Interactive Builder User Guide will have you creating interactives right away. It covers everything from logging 
            in to saving to exporting and breaks down each step of the process. 
          </Typography>

          <br />

          <Button 
            variant="contained"
            color="primary"
            endIcon={<i className="fas fa-file-pdf"></i>}
            className={classes.button}
            component="a"
            href="/PAVILION Interactive Builder User Guide.pdf" 
            download
          >
            Download
          </Button>

          <Divider />

          <Typography className={classes.sectionHeading} component="h2" variant="h6">
            Contact
          </Typography>

          <Typography className={classes.paragraph} component="p">
            Need support or have questions? The PAVILION team is here to help. Reach out to us at <Link className={classes.link} href="mailto:pavilion@dinfos.edu?subject=Need support with PAVILION Interactive Builder Tool">pavilion@dinfos.edu</Link> with your question and we will get back to you with an answer.
          </Typography>
        </Card>

      </div>


      
    </div>
  )
}